import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DRAPCODE } from 'drapcode-constant';
import * as actions from './redux/actions';
import * as dataConnectorActions from '../data-connector/redux/actions';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import ExternalSourceHeaderNav from '../../common/headerNav/ExternalSourceHeaderNav';
import { parseExtractPluginCode } from '../../common/utils/plugin_utils';
import { checkToShowSaveBtn } from '../plugin/utils';
import CollectionList from './CollectionList';

export class DefaultPage extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { activeTab: DRAPCODE, headers: [] };

  componentDidMount = async () => {
    const { home, match, dataConnectorActions } = this.props;
    const { iPlugins } = home;
    const { projectId, version } = match.params;
    const headers = parseExtractPluginCode(iPlugins, 'COLLECTIONS');
    await dataConnectorActions.getExternalDataBase({ projectId, version });
    const { dataConnector } = this.props;
    const { externalDataBaseData } = dataConnector || '';

    if (externalDataBaseData) {
      const dataTypes = [...new Set(externalDataBaseData.map((item) => item.type))];
      if (dataTypes) {
        headers.push(...dataTypes);
      }
    }

    let connectorType = DRAPCODE;
    this.setState({ activeTab: connectorType, headers });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    const { activeTab: currActiveTab } = this.state;
    let connectorType = '';
    if (!currActiveTab || !checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'COLLECTIONS');

      const { dataConnector } = this.props;
      const { externalDataBaseData } = dataConnector || '';
      if (externalDataBaseData) {
        const dataTypes = [...new Set(externalDataBaseData.map((item) => item.type))];
        if (dataTypes) {
          headers.push(...dataTypes);
        }
      }

      connectorType = DRAPCODE;
      this.setState({ activeTab: connectorType, headers });
    }
    return true;
  }

  toggle = (tab) => {
    this.setState({ activeTab: tab });
  };

  showSourceDocumentation = (activeTab) => {
    if (activeTab === DRAPCODE) {
      return (
        <>
          <h5>
            <b>Introduction to Collections</b>
          </h5>
          <p>
            DrapCode not only helps you build a no code front end but also offers you a no code
            inbuilt database for your web applications through collections, in which data can be
            stored manually as well as dynamically.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/introduction-to-collections" />
        </>
      );
    }
    return 'No Doc';
  };

  showTabBody = (header) => {
    const { activeTab } = this.state;
    const { match } = this.props;
    const { projectId, version } = match.params;
    return (
      <div className={`tab-pane ${activeTab === header && 'active'}`} key={header}>
        <div className="row mx-auto">
          <CollectionList version={version} projectId={projectId} activeTab={activeTab} />
          <ParentDocCard>{this.showSourceDocumentation(activeTab)}</ParentDocCard>
        </div>
      </div>
    );
  };

  render() {
    const { match } = this.props;
    const { projectId, version } = match.params;
    const { headers, activeTab } = this.state;

    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <ExternalSourceHeaderNav
              title="Collections"
              titleIcon="collection"
              projectId={projectId}
              version={version}
              headers={headers}
              activeTab={activeTab}
              enableRestApi={false}
              enableZapier={false}
              enableDrapcode={true}
              toggle={this.toggle}
            />
            <div className="row mx-auto">
              <div className="tab-content w-100">
                {[DRAPCODE, ...headers].map((header) => this.showTabBody(header))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    dataConnectorActions: bindActionCreators({ ...dataConnectorActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
